"use strict";

module.exports = function (column) {
  if (this.opts.visibleColumns) {
    return this.opts.visibleColumns.includes(column);
  }

  if (this.opts.hiddenColumns) {
    return !this.opts.hiddenColumns.includes(column);
  }

  return true;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/should-show-column-on-init.js
// module id = 1653
// module chunks = 61